module.exports = __webpack_public_path__ + "img/client-server-icon.48274089.svg";